module.exports = __webpack_public_path__ + "img/16.dbb2bbd1.jpg";